interface NavbarProps {
  dark?: boolean;
}

export default function Navbar({ dark = false }: NavbarProps) {
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-line/70 bg-cream/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap" aria-label="媚黑大赛 首页">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-ember-500 font-display text-sm font-black text-white">
            媚
          </span>
          <span className="font-display text-lg font-black tracking-wide text-ink">
            媚黑大赛<span className="ml-1 text-[11px] font-sans font-medium text-clay">话题观察站</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          <a href="#suolan" className="whitespace-nowrap rounded-md px-3 py-2 text-[13px] font-medium text-ink/80 transition-colors hover:bg-ember-50 hover:text-ember-600">
            速览索引
          </a>
          <a href="#pandian" className="whitespace-nowrap rounded-md px-3 py-2 text-[13px] font-medium text-ink/80 transition-colors hover:bg-ember-50 hover:text-ember-600">
            同类盘点
          </a>
          <a href="#mailuo" className="whitespace-nowrap rounded-md px-3 py-2 text-[13px] font-medium text-ink/80 transition-colors hover:bg-ember-50 hover:text-ember-600">
            事件脉络
          </a>
          <a href="#duibi" className="whitespace-nowrap rounded-md px-3 py-2 text-[13px] font-medium text-ink/80 transition-colors hover:bg-ember-50 hover:text-ember-600">
            横向对比
          </a>
          <a href="#cidian" className="whitespace-nowrap rounded-md px-3 py-2 text-[13px] font-medium text-ink/80 transition-colors hover:bg-ember-50 hover:text-ember-600">
            概念速查
          </a>
        </nav>

        <div className="flex items-center gap-2">
          <span className="hidden items-center gap-1.5 rounded-full border border-line bg-paper px-3 py-1.5 text-xs font-medium text-clay sm:inline-flex">
            <i className="ri-refresh-line" aria-hidden="true"></i>
            更新于 2026·09
          </span>
          <a
            href="#pandian"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-ink px-4 py-2 text-[13px] font-semibold text-cream transition-colors hover:bg-ember-600"
          >
            去看盘点
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <button
          className="grid h-10 w-10 place-items-center rounded-md border border-line bg-paper text-ink lg:hidden"
          aria-label="打开菜单"
          onClick={() => {
            const panel = document.getElementById('mobile-nav');
            panel?.classList.toggle('hidden');
          }}
        >
          <i className="ri-menu-line text-xl" aria-hidden="true"></i>
        </button>
      </div>

      <div id="mobile-nav" className="hidden border-t border-line/70 bg-cream/95 lg:hidden">
        <div className="mx-auto flex max-w-7xl flex-wrap gap-1 px-4 py-3 md:px-6">
          {navItems.map((it) => (
            <a
              key={it.label}
              href={it.href}
              onClick={() => document.getElementById('mobile-nav')?.classList.add('hidden')}
              className="whitespace-nowrap rounded-full bg-paper px-3 py-2 text-[13px] font-medium text-ink/80 hover:text-ember-600"
            >
              {it.label}
            </a>
          ))}
        </div>
      </div>
    </header>
  );
}

const navItems = [
  { label: '速览索引', href: '#suolan' },
  { label: '同类盘点', href: '#pandian' },
  { label: '事件脉络', href: '#mailuo' },
  { label: '横向对比', href: '#duibi' },
  { label: '舆论现场', href: '#shengyin' },
  { label: '概念速查', href: '#cidian' },
  { label: '常见疑问', href: '#faq' },
];